module.exports = __webpack_public_path__ + "img/mujer-coche.42d5a6b7.jpg";